import React from 'react';
import FundingReportChartCard, { FundingReportBarChart } from './FundingReportChartCard';

const formatCurrency = (value) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value || 0);

const FundingCommissionReport = ({ data, loading }) => {
  if (loading) return <p className="text-sm text-[var(--fg-muted)]">Loading commission report...</p>;
  if (!data) return <p className="text-sm text-[var(--fg-muted)]">No commission data available.</p>;

  const advisorItems = (data.commissionByAdvisor || []).map((row) => ({
    label: row.advisorUserId,
    value: Math.round(row.totalCommission || 0),
  }));

  return (
    <div className="space-y-4">
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {[
          ['Projected', data.projectedCommissions],
          ['Earned', data.earnedCommissions],
          ['Paid', data.paidCommissions],
          ['Pending payout', data.pendingPayout],
          ['Reversed', data.reversedCommissions],
        ].map(([label, value]) => (
          <div key={label} className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-4 py-3">
            <div className="text-xs text-[var(--fg-muted)]">{label}</div>
            <div className="text-lg font-bold text-[var(--fg-text)]">{formatCurrency(value)}</div>
          </div>
        ))}
      </div>
      <FundingReportChartCard title="Commission by advisor" subtitle="Earned and projected totals">
        <FundingReportBarChart items={advisorItems} />
      </FundingReportChartCard>
      <div className="overflow-x-auto">
        <table className="min-w-full text-left text-sm">
          <thead>
            <tr className="border-b border-[var(--fg-line)] text-[var(--fg-muted)]">
              <th className="px-3 py-2">Lender</th>
              <th className="px-3 py-2">Product</th>
              <th className="px-3 py-2">Commission</th>
              <th className="px-3 py-2">Count</th>
            </tr>
          </thead>
          <tbody>
            {(data.commissionByLenderProduct || []).map((row) => (
              <tr key={`${row.lenderName}-${row.productType}`} className="border-b border-[var(--fg-line)]/70">
                <td className="px-3 py-2">{row.lenderName}</td>
                <td className="px-3 py-2">{row.productType}</td>
                <td className="px-3 py-2">{formatCurrency(row.totalCommission)}</td>
                <td className="px-3 py-2">{row.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <FundingReportChartCard title="Clawback monitoring" subtitle="Commissions under clawback review">
        {(data.clawbackMonitoring || []).length === 0 ? (
          <p className="text-sm text-[var(--fg-muted)]">No clawback monitoring items.</p>
        ) : (
          <div className="space-y-2 text-sm">
            {data.clawbackMonitoring.map((row) => (
              <div key={row.id} className="flex justify-between rounded-lg bg-white px-3 py-2 dark:bg-slate-950/20">
                <span>{row.clientName} · {row.lenderName}</span>
                <span>{formatCurrency(row.commissionAmount)} · {row.clawbackStatus}</span>
              </div>
            ))}
          </div>
        )}
      </FundingReportChartCard>
    </div>
  );
};

export default FundingCommissionReport;
